<button
  mat-icon-button
  class="filter-clear-button"
  aria-label="Clear filter"
  [title]="title()"
  type="button"
  (click)="$event.stopPropagation(); onClearFilterButtonClick()"
>
  <mat-icon class="filter-clear-button__icon">{{ icon() }}</mat-icon>
</button>
